import React, { useEffect, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button } from 'react-bootstrap';
import { event } from 'jquery';
import Event5 from './event/Event5';
const localizer = momentLocalizer(moment);

const MyEventCalendar = () => {
    const [currentDate, setCurrentDate] = useState(new Date());
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setCurrentDate(new Date());
    }, []);
    const events = [
        {
            start: new Date(2025, 2, 1, 10, 0), // March 1, 2025, 10:00 AM
            end: new Date(2025, 2, 1, 12, 0),
            title: 'Project Management',
            description: 'Project Management',
            path: '/event-1'
        },
        {
            start: new Date(2025, 2, 21, 10, 0), // March 21, 2025, 10:00 AM 
            end: new Date(2025, 2, 21, 12, 0),
            title: 'Advancements in Cooling Tower Design and Technology',
            description: 'Advancements in Cooling Tower Design and Technology',
            path: '/event-2'
        },
        {
            start: new Date(2025, 2, 5, 10, 0), // March 5, 2025, 10:00 AM
            end: new Date(2025, 2, 5, 12, 0),
            title: 'She Alliance',
            description: 'Leading Women in Consulting Architecture, Shaping the Future of HVAC Industries',
            path: '/event-4'
        },
        {
            start: new Date(2025, 1, 7, 10, 0), // February 7, 2025, 10:00 AM
            end: new Date(2025, 1, 7, 12, 0),
            title: 'Workshop on Kitchen Ventilation',
            description: 'Workshop on Kitchen Ventilation',
            path: '/event-3'
        },
        {
            start: new Date(2025, 4, 3, 10, 0), // May 3, 2025, 10:00 AM
            end: new Date(2025, 4, 3, 12, 0),
            title: 'ICE Workshop',
            description: 'IEC Workshop on Advancement in Cooling Tower Design and Technology',
            path: '/event-5'
        },
        {
            start: new Date(2025, 4, 13, 10, 0), // May 13, 2025, 10:00 AM
            end: new Date(2025, 4, 13, 12, 0),
            title: 'Net Efficiency Impact on Central Air-conditioning Systems',
            description: 'Impact of VFDs on Cooling Towers in Central Air-conditioning Systems',
            path: '/event-6'
        },
        {
            start: new Date(2025, 4, 16, 10, 0), // May 16, 2025, 10:00 AM
            end: new Date(2025, 4, 16, 11, 30),
            title: 'Decarbonisation of the Buildings Sector',
            description: 'Decarbonisation of the Buildings Sector',
            path: '/event-7'
        },
        {
            start: new Date(2025, 4, 16, 14, 0), // May 16, 2025, 2:00 PM
            end: new Date(2025, 4, 16, 15, 30),
            title: 'Online Webinar on World Technology Day',
            description: 'An Online Webinar on World Technology Day',
            path: '/event-8'
        },
        {
            start: new Date(2025, 4, 18, 10, 0), // May 18, 2025, 10:00 AM
            end: new Date(2025, 4, 18, 13, 0),
            title: 'South Asia’s Premier Refrigeration & Cold-Chain Exhibition',
            description: 'Exhibition focused on Refrigeration and Cold-Chain technologies in South Asia',
            path: '/event-9'
        },
        {
            start: new Date(2025, 4, 24, 10, 0), // May 24, 2025, 10:00 AM
            end: new Date(2025, 4, 24, 12, 0),
            title: 'Acoustics & Indoor Environmental Quality',
            description: 'Exploring advancements in acoustics and indoor environmental quality',
            path: '/event-10'
        },
        {
        start: new Date(2025, 5, 7, 15, 0), // June 7, 2025, 3:00 PM
        end: new Date(2025, 5, 7, 17, 30),
        title: 'ISHRAE Knowledge Talk on ALL ABOUT HVAC PUMPS',
        description: 'ISHRAE Knowledge Talk on ALL ABOUT HVAC PUMPS',
        path: '/event-11'
    },
    {
        start: new Date(2025, 5, 13, 16, 0), // June 13, 2025, 4:00 PM
        end: new Date(2025, 5, 13, 18, 0),
        title: 'HVAC Hydronics System Design Optimisation',
        description: 'ISHRAE Knowledge Talk on HVAC Hydronics System Design Optimization',
        path: '/event-12'
    },
    {
        start: new Date(2025, 5, 14, 9, 30), // June 14, 2025, 9:30 AM
        end: new Date(2025, 5, 14, 16, 0),
        title: 'DELHI TO HOST A FULL DAY WORKSHOP BUILT ENVIRONMENT NBC - THE CHANGE AWAITED',
        description: 'DELHI TO HOST A FULL DAY WORKSHOP BUILT ENVIRONMENT NBC - THE CHANGE AWAITED',     
        path: '/event-13'
    },
    {
        start: new Date(2025, 5, 14, 16, 0), // June 14, 2025, 4:00 PM
        end: new Date(2025, 5, 14, 18, 0),
        title: 'Distinguished Lecture on Energy Efficiency & Renewable Energy',
        description: 'Distinguished Lecture on Energy Efficiency & Renewable Energy',
        path: '/event-14'
    },
    {
        start: new Date(2025, 5, 28, 16, 0), // June 28, 2025, 4:00 PM
        end: new Date(2025, 5, 28, 18, 0),
        title: 'ACRESERVE - Technical program for Technician',
        description: 'ACRESERVE - Technical program for Technician',
        path: '/event-15'
    },
    {
        start: new Date(2025, 6, 25, 16, 0), // June 28, 2025, 4:00 PM                           
        end: new Date(2025, 6, 25, 18, 0),
        title: 'ISHRAE Knowledge Talk on Latest design trends in Switchgear & Controlgear technology & a brief overview of IEC standards for Panels',
        description: 'ISHRAE Knowledge Talk on Latest design trends in Switchgear & Controlgear technology & a brief overview of IEC standards for Panels',
        path: '/event-16'
    },
    {
        start: new Date(2025, 7, 8, 16, 0), // June 28, 2025, 4:00 PM
        end: new Date(2025, 7, 8, 18, 0),
        title: 'Distinguished Lecture on Field Measurements & Data Storage in HVAC',
        description: 'Distinguished Lecture on Field Measurements & Data Storage in HVAC',
        path: '/event-17'
    },
    {
        start: new Date(2025, 9, 4, 16, 0), // June 28, 2025, 4:00 PM                           
        end: new Date(2025, 9, 4, 18, 0),
        title: 'CLIMATE SUMMIT',
        description: 'CLIMATE SUMMIT',
        path: '/event-18'
    },
    {
        start: new Date(2025, 7, 22, 16, 0), // June 28, 2025, 4:00 PM                           
        end: new Date(2025, 7, 22, 18, 0),
        title: 'REFCON',
        description: 'REFCON',
        path: '/event-19'
    },
    {
        start: new Date(2025, 10, 1, 16, 0), // June 28, 2025, 4:00 PM                           
        end: new Date(2025, 10, 8, 18, 0),
        title: 'DCI CUP 2025',
        description: 'DCI CUP 2025',
        path: '/event-20'
    },
    {
        start: new Date(2025, 10, 8, 16, 0), // June 28, 2025, 4:00 PM                           
        end: new Date(2025, 10, 8, 18, 0),
        title: 'IEC workshop on Corrosion Controls',
        description: 'IEC workshop on Corrosion Controls',
        path: '/event-21'
    },
    {
        start: new Date(2025, 11, 14, 16, 0), // June 28, 2025, 4:00 PM                           
        end: new Date(2025, 11, 14, 18, 0),
        title: 'Youth summit 2025',
        description: 'Youth summit 2025',
        path: '/event-22'
    },
    {
        start: new Date(2025, 11, 13, 16, 0), // June 28, 2025, 4:00 PM                           
        end: new Date(2025, 11, 13, 18, 0),
        title: 'Pharma Connect with HVAC&R',
        description: 'Pharma Connect with HVAC&R',
        path: '/event-23'
    }
    ];
    

    const handleSelectEvent = (event) => {
            if (event.pdfUrl) {
                window.open(event.pdfUrl, '_blank');
            } else if (event.path) {
                window.open(event.path, '_blank');
            }
        
    };

    const handleClose = () => setShowModal(false);

    const formatDateRange = (start, end) => {
        return `${moment(start).format('MMMM D, YYYY h:mm A')} - ${moment(end).format('h:mm A')}`;
    };

    return (
        <div style={{ height: '500px'}} className='container'>
            <Calendar
                localizer={localizer}
                events={events}
                startAccessor="start"
                endAccessor="end"
                style={{ height: '100%' }}
                date={currentDate}
                onNavigate={date => setCurrentDate(date)}
                views={{ month: true, week: true, day: true }}
                onSelectEvent={handleSelectEvent}
            />

            <Modal show={showModal} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{selectedEvent ? selectedEvent.title : 'Modal title'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedEvent ? (
                        <>
                            <p>{selectedEvent.description}</p>
                            <p><strong>Date:</strong> {formatDateRange(selectedEvent.start, selectedEvent.end)}</p>
                        </>
                    ) : (
                        '...' 
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default MyEventCalendar;
